import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {getLcKndType} from "../../api/apiClient";


const ComboOcrncType = ({
                          propLabel = '발생유형',
                          propOnChange = null,
                          propValue = null
                        }) => {

  /* 발생유형 목록 data */
  const [stLcKndList, setLcKndList] = useState([]);

  /* 발생유형 목록 갱신 */
  const updateLcKndList = () => {
    getLcKndType()
        .then((res) => {
              // console.log(res.data.data.list);
              setLcKndList(res.data.data.list);
            }
        );
  };

  useEffect(() => {
    updateLcKndList();
  }, []);

  return (
      /*<Form.Group as={Row} controlId="formBasicSelectMenu">
        <Form.Label column md={3} className={"label text-end"}>
          {propLabel}
        </Form.Label>
        <Col md={9} className={""}>
          <Form.Select
              aria-label="LcKnd Select"
              className={"input input-select"}
              onChange={propOnChange}
          >
            <option value={""}>전체</option>
            {Array.isArray(stLcKndList) ?
                (stLcKndList.map((elem, idx) => {
                  return (
                      <option key={idx} value={elem.cd}>{elem.nm}</option>
                  )
                })) : ''}
          </Form.Select>
        </Col>
      </Form.Group>*/
      <Form.Group as={Row} controlId="formBasicSelectMenu">
        <Form.Label
            className={`col-form-label label text-end`}
            style={{width: "100px"}}
        >
          {propLabel}
        </Form.Label>
        <Col>
          <Form.Select
              aria-label="LcKnd Select"
              className={"input input-select"}
              onChange={propOnChange}
              defaultValue={propValue}
          >
            <option value={""}>전체</option>
            {Array.isArray(stLcKndList) ?
                (stLcKndList.map((elem, idx) => {
                  return (
                      <option key={idx} value={elem.cd}>{elem.nm}</option>
                  )
                })) : ''}
          </Form.Select>
        </Col>
      </Form.Group>
  );
}

export default ComboOcrncType;





